import { render, staticRenderFns } from "./FreeTextProductModal.vue?vue&type=template&id=6963bd7e&scoped=true&"
import script from "./FreeTextProductModal.vue?vue&type=script&lang=js&"
export * from "./FreeTextProductModal.vue?vue&type=script&lang=js&"
import style0 from "./FreeTextProductModal.vue?vue&type=style&index=0&id=6963bd7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963bd7e",
  null
  
)

export default component.exports